
import { defineComponent, ref, reactive, onMounted, inject, computed } from 'vue'
import { FormInstance, FormRules, ElNotification } from "element-plus";
//services
import acrdService from "@/core/services/AcrdService";
import sportService from "@/core/services/SportService"
import { errManager } from "@/core/config/Tools";
import { useI18n } from "vue-i18n/index";
import GlobalService from '@/core/services/GlobalService';
import { useStore } from "vuex";

interface Field {
  idcompany: number;
  idformfield : number;
  idregister: string;
  form_step: number;
  field_label: string;
  field_name: number;
  field_type: number;
  field_length: number;
  required: number;
}

export default defineComponent({
    name: "step-competition",
    props: {
        idacrd: {
            type: String,
            required: true,
            default: ""
        },
        idevent: {
            type: String,
            required: true,
            default: ""
        },
        idsport: {
            type: String,
            required: true,
            default: ""
        }
    },
    setup(props) {
        const { t } = useI18n();
        const loader = ref(false)
        const loadingTest = ref(false)
        const formRef = ref<FormInstance>()
        const store = useStore();
        const form = reactive(<any>{
            idteam: '',
            idtest: null,
            target: 'competition',
            fields: {}
        })
        const rules = reactive<FormRules>({});
        const listFields = ref<Field[]>([]);
        const listSetting = ref<any>([])
        const listTest = ref<any>([])
        const listMiTest = ref<any>([])
        const rowAcrd = inject<any>('rowAcrd') //obtener la preinfo que será asignada a la etiqueta for
        const formData = reactive<Record<string, string>>({});

        const username: any = computed < any > (() => {
            return store.getters.currentUser.account;
        });

        const getSetting = async () => {
            await sportService.getParams({
                idevent: props.idevent,
                idsport: props.idsport
            }).then((res) => {
                //console.log(res.data)
                listSetting.value = res.data
                //console.log(form.idteam = listSetting.value.cmp[0].id)
                //console.log(form.idteam)
                if (res.data) {
                    //asignar el primer registro
                    //form.idteam = listSetting.value.cmp[0].id
                }
            }).catch(({ response }) => {
                errManager(response)
            })
        }

        //get fields dynamics
        const getListTypeFile = async () => {
            await GlobalService.get('api/formfields', `${props.idsport}/2`)
                .then((res) => {
                    listFields.value = res.data;
                    //listFields.value.forEach(f=>{
                        /*
                        const fieldRules: any[] = [];

                         if (f.required == 1) {
                            fieldRules.push({
                            validator: (rule: any, value: string, callback: any) => {
                                if (!value || value.trim() === "") {
                                callback(new Error(`El campo ${f.field_label} es obligatorio`));
                                } else {
                                callback();
                                }
                            },
                            trigger: ["blur", "change"]
                            });
                        }
                        // Guardar en rules
                        rules[f.field_name] = fieldRules;
                        */
                    //})
                }).catch(({ response }) => {
                    errManager(response)
                })
        }

        //obtener la lista de pruebas segun la modalidad
        const getTest = async () => {
            loader.value = true
            form.idtest = null
            if (form.idteam != '') {
                listTest.value = []
                await sportService.getTest({
                    idevent: props.idevent,
                    idsport: props.idsport,
                    cmp: form.cmp,
                    nivel: form.idniv,
                    gender: rowAcrd.value.gender ?? form.gender,
                }).then((res) => {
                    listTest.value = res.data
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
            }
        }

        const saveTest = async () => {
            if (form.idtest != null) {
                loadingTest.value = true
                await acrdService.saveTestAtlete({
                    idevent: props.idevent,
                    idsport: props.idsport,
                    idacrd: props.idacrd,
                    idcmp: form.cmp,
                    idniv: form.idniv,
                    idtest: form.idtest,
                    idcat: rowAcrd.value.gender ?? form.gender,
                    param1: form.param1,
                }).then((res) => {
                    loadingTest.value = false
                    if (res.data.status == 'success') {
                        form.idtest = null
                        getMiTests()
                    }
                    ElNotification({
                        title: res.data.title,
                        message: res.data.message,
                        type: res.data.status,
                    })
                }).catch(({ response }) => {
                    loadingTest.value = false
                    errManager(response)
                })
            } else {
                ElNotification({
                    title: process.env.VUE_APP_NAME,
                    message: 'Falta seleccionar la prueba a agregar',
                    type: 'error',
                })
            }


        }

        //mis pruebas marcadas
        const getMiTests = async () => {
            loadingTest.value
            await acrdService.getAtletaTest({
                id: props.idacrd
            }).then((res) => {
                loadingTest.value = false
                listMiTest.value = res.data
            }).catch(({ response }) => {
                loadingTest.value = false
                errManager(response)
            })
        }

        const getAcrd = async () => {
            loader.value = true
            await acrdService.getAcreditation(props.idacrd, 'show')
                .then((res) => {
                    Object.assign(form, res.data.info, res.data.person);
                    /*if(res.data.info.fields){
                        const fields = JSON.parse(res.data.info.fields)
                        Object.keys(fields).forEach(key => {
                            form.fields[key] = fields[key];
                        });
                    }
                    */
                        //form.fields = JSON.parse(res.data.info.fields )
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const onDeleteTest = async (idtest) => {
            loadingTest.value = true
            acrdService.deleteTestAtlete({ idtest: idtest })
                .then((res) => {
                    loadingTest.value = false
                    getMiTests()
                    ElNotification({
                        title: res.data.title,
                        message: res.data.message,
                        type: res.data.status,
                    })
                }).catch(({ response }) => {
                    loadingTest.value = false
                    errManager(response)
                })
        };

        const getCompetencia = () => {
            form.idniv = null;
            
            const found = listSetting.value?.cmp.find(item => item.id === form.cmp);

            if (found && Array.isArray(found.subitems) && found.subitems.length > 0) {
                listSetting.value.nv =  found.subitems
            }

            //listSetting.value
        }

        onMounted(() => {
            getListTypeFile();
            getSetting()
            //getTest()
            getMiTests()
            if (props.idacrd)
                getAcrd()
        })

        return {
            t,
            loader,
            loadingTest,
            formRef,
            form,
            rules,
            listSetting,
            listTest,
            listMiTest,
            rowAcrd,
            listFields,
            formData,
            username,

            //events,
            getListTypeFile,
            getSetting,
            getTest,
            saveTest,
            getMiTests,
            onDeleteTest,
            getCompetencia

        }

    },
})
